export default __webpack_public_path__ + "static/ladd_roberts-c414397afccc96b786d53c26ab234bbf.jpg";